export default {
  validate(formData) {
    const errors = {};

    if (!formData.business?.businessName?.trim()) {
      errors.business_businessName = 'Business Name is required';
    }
    if (!formData.business?.businessAddress?.trim()) {
      errors.business_businessAddress = 'Business Address is required';
    }
    if (!formData.business?.businessTel?.trim()) {
      errors.business_businessTel = 'Business Tel. No is required';
    }
    if (!formData.jobAddress?.jobName?.trim()) {
      errors.jobAddress_jobName = 'Name is required';
    }
    if (!formData.jobAddress?.jobAddress?.trim()) {
      errors.jobAddress_jobAddress = 'Address is required';
    }
    if (!formData.jobAddress?.jobTel?.trim()) {
      errors.jobAddress_jobTel = 'Tel. No is required';
    }
    if (!formData.jobAddress?.accommodationRented?.trim()) {
      errors.jobAddress_accommodationRented = 'Is Accommodation Rented? (Y/N) is required';
    }
    if (!formData.heatPumpDetails?.unitMake?.trim()) {
      errors.heatPumpDetails_unitMake = 'Unit Make is required';
    }
    if (!formData.heatPumpDetails?.unitModel?.trim()) {
      errors.heatPumpDetails_unitModel = 'Unit Model is required';
    }
    if (!formData.heatPumpDetails?.serialNumber?.trim()) {
      errors.heatPumpDetails_serialNumber = 'Serial Number is required';
    }
    if (!formData.heatPumpDetails?.mcsCertificationNumber?.trim()) {
      errors.heatPumpDetails_mcsCertificationNumber = 'MCS Certification Number is required';
    }
    if (!formData.heatPumpDetails?.installationDate?.trim()) {
      errors.heatPumpDetails_installationDate = 'Installation Date is required';
    }
    if (!formData.heatPumpInspection?.physicalDamage?.trim()) {
      errors.heatPumpInspection_physicalDamage = 'Are there any signs of physical damage or obstructions? is required';
    }
    if (!formData.heatPumpInspection?.unitFreeOfLeaves?.trim()) {
      errors.heatPumpInspection_unitFreeOfLeaves = 'Is the unit free of leaves/debris? is required';
    }
    if (!formData.heatPumpInspection?.airFiltersCleaned?.trim()) {
      errors.heatPumpInspection_airFiltersCleaned = 'Have air filters (indoor units) been cleaned/replaced? is required';
    }
    if (!formData.heatPumpInspection?.evaporatorCoilsInspected?.trim()) {
      errors.heatPumpInspection_evaporatorCoilsInspected = 'Have evaporator/condenser coils been inspected and cleaned? is required';
    }
    if (!formData.heatPumpInspection?.insulationIntact?.trim()) {
      errors.heatPumpInspection_insulationIntact = 'Is the insulation around the refrigerant pipes intact and undamaged? is required';
    }
    if (!formData.heatPumpInspection?.electricalConnectionsSecure?.trim()) {
      errors.heatPumpInspection_electricalConnectionsSecure = 'Are electrical connections and components secure and undamaged? is required';
    }
    if (!formData.heatPumpInspection?.condensateDrainCleared?.trim()) {
      errors.heatPumpInspection_condensateDrainCleared = 'Has the condensate drain been cleared? is required';
    }
    if (!formData.heatPumpInspection?.fanBladesSmoothRunning?.trim()) {
      errors.heatPumpInspection_fanBladesSmoothRunning = 'Are the fan, blades and motor running smoothly without abnormal sounds or vibrations? is required';
    }
    if (!formData.heatPumpInspection?.refrigerantLevelsAdhere?.trim()) {
      errors.heatPumpInspection_refrigerantLevelsAdhere = 'Do refrigerant levels adhere to F-Gas regulations? is required';
    }
    if (!formData.heatPumpInspection?.controllerInspected?.trim()) {
      errors.heatPumpInspection_controllerInspected = 'Has the system&#x27;s controller been inspected for any fault codes and reset if necessary? is required';
    }
    if (!formData.heatPumpInspection?.defrostSensorTested?.trim()) {
      errors.heatPumpInspection_defrostSensorTested = 'Has the defrost sensor or timer been tested, ensuring proper cycle operation? is required';
    }
    if (!formData.heatPumpInspection?.temperatureDifferenceMeasured?.trim()) {
      errors.heatPumpInspection_temperatureDifferenceMeasured = 'Has the temperature difference between flow and return water been measured? is required';
    }
    if (!formData.heatPumpInspection?.waterPressureInRange?.trim()) {
      errors.heatPumpInspection_waterPressureInRange = 'Is the water pressure in the heating loop within the manufacturer&#x27;s recommended range? is required';
    }
    if (!formData.heatPumpInspection?.unitCheckedNoiseVibration?.trim()) {
      errors.heatPumpInspection_unitCheckedNoiseVibration = 'Has the unit been checked for abnormal noise/vibration? is required';
    }
    if (!formData.hotWaterCylinderDetails?.cylinderMake?.trim()) {
      errors.hotWaterCylinderDetails_cylinderMake = 'Cylinder Make is required';
    }
    if (!formData.hotWaterCylinderDetails?.cylinderModel?.trim()) {
      errors.hotWaterCylinderDetails_cylinderModel = 'Cylinder Model is required';
    }
    if (!formData.hotWaterCylinderDetails?.cylinderSerialNumber?.trim()) {
      errors.hotWaterCylinderDetails_cylinderSerialNumber = 'Serial Number is required';
    }
    if (!formData.hotWaterCylinderDetails?.cylinderCapacity?.trim()) {
      errors.hotWaterCylinderDetails_cylinderCapacity = 'Capacity (Litres) is required';
    }
    if (!formData.hotWaterCylinderDetails?.cylinderInstallationDate?.trim()) {
      errors.hotWaterCylinderDetails_cylinderInstallationDate = 'Installation Date is required';
    }
    if (!formData.cylinderInspection?.cylinderPipeworkNoLeaks?.trim()) {
      errors.cylinderInspection_cylinderPipeworkNoLeaks = 'Is the cylinder/pipework free from signs of leaks, rust or corrosion? is required';
    }
    if (!formData.cylinderInspection?.pressureReliefValveFunctioning?.trim()) {
      errors.cylinderInspection_pressureReliefValveFunctioning = 'Is the pressure relief valve functioning correctly and not leaking? is required';
    }
    if (!formData.cylinderInspection?.temperaturePressureWithinLimits?.trim()) {
      errors.cylinderInspection_temperaturePressureWithinLimits = 'Are the temperature and pressure settings within recommended limits? is required';
    }
    if (!formData.cylinderInspection?.expansionVesselWithinSpecs?.trim()) {
      errors.cylinderInspection_expansionVesselWithinSpecs = 'Is the expansion vessel&#x27;s charge within manufacturer specifications? is required';
    }
    if (!formData.cylinderInspection?.heatExchangerClean?.trim()) {
      errors.cylinderInspection_heatExchangerClean = 'Is the heat exchanger coil clean and free from build-up of scale? is required';
    }
    if (!formData.cylinderInspection?.insulationJacketGood?.trim()) {
      errors.cylinderInspection_insulationJacketGood = 'Is the insulation jacket free of damage or wear and meets current building regulations? is required';
    }
    if (!formData.cylinderInspection?.anodeFreeCorrosion?.trim()) {
      errors.cylinderInspection_anodeFreeCorrosion = 'Is the anode free from corrosion? is required';
    }
    if (!formData.cylinderInspection?.thermostatControllingTemp?.trim()) {
      errors.cylinderInspection_thermostatControllingTemp = 'Is the thermostat correctly controlling the water temperature? is required';
    }
    if (!formData.cylinderInspection?.noErrorCodes?.trim()) {
      errors.cylinderInspection_noErrorCodes = 'Are there error codes present on the cylinder&#x27;s digital display? (if applicable) is required';
    }
    if (!formData.cylinderInspection?.cylinderDeliveringCorrectTemp?.trim()) {
      errors.cylinderInspection_cylinderDeliveringCorrectTemp = 'Is the cylinder delivering hot water at the correct temperature and flow rate? is required';
    }
    if (!formData.workCarriedOut?.workCarriedOut?.trim()) {
      errors.workCarriedOut_workCarriedOut = 'Work Carried Out is required';
    }
    if (!formData.receivedBy?.receivedByName?.trim()) {
      errors.receivedBy_receivedByName = 'Print Name is required';
    }
    if (!formData.receivedBy?.receivedByDate?.trim()) {
      errors.receivedBy_receivedByDate = 'Date is required';
    }
    if (!formData.issuedBy?.engineerSignature?.trim()) {
      errors.issuedBy_engineerSignature = 'Signature is required';
    }
    if (!formData.issuedBy?.issuedByDate?.trim()) {
      errors.issuedBy_issuedByDate = 'Date is required';
    }
    if (!formData.nextService?.nextServiceDate?.trim()) {
      errors.nextService_nextServiceDate = 'The next service is due is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};
